import CHECKOUT_MUTATIONS from './checkout-mutations'
import FAVORITE_MUTATIONS from './favorite-mutations'

export default {
  ...CHECKOUT_MUTATIONS,
  ...FAVORITE_MUTATIONS,
}
